<template>
  <div>
    <Loader />
    <section class="sign-in-page">
      <b-container class="bg-white mt-5 p-0">
        <div class="row no-gutters">
          <div class="col-sm-6 align-self-center">
            <div class="sign-in-from">
              <router-view></router-view>
            </div>
          </div>
          <div class="col-sm-6 text-center">
            <div class="sign-in-detail text-white"
              :style="'background: url(' + bgImageURL + ') no-repeat 0 0; background-size: cover;'">
              <!-- <a class="sign-in-logo mb-5" href="#"><img :src="logo" class="img-fluid" alt="logo"></a> -->
              <div style="margin-bottom: 30px; font-size: 30px; font-weight: 800;">
                榮華“付”貴
              </div>
              <Swiper :options="options">
                <SwiperSlide class="item">
                  <img :src="require('../../assets/images/login/login-1.png')" class="img-fluid mb-4" alt="logo">
                  <h4 class="mb-1 text-white">高效审核</h4>
                  <p>我们的智能审核系统能够快速处理出款和入款订单，显著缩短审核时间，确保资金流动更加顺畅高效，提升您的使用体验。</p>
                </SwiperSlide>
                <SwiperSlide class="item">
                  <img :src="require('../../assets/images/login/login-1.png')" class="img-fluid mb-4" alt="logo">
                  <h4 class="mb-1 text-white">安全保障</h4>
                  <p>平台采用先进的加密技术和多重身份验证机制，确保每笔交易的安全性，让您在资金管理中安心无忧，保护您的资金安全。</p>
                </SwiperSlide>
                <SwiperSlide class="item">
                  <img :src="require('../../assets/images/login/login-1.png')" class="img-fluid mb-4" alt="logo">
                  <h4 class="mb-1 text-white">实时监控</h4>
                  <p>提供实时数据分析和监控功能，帮助您随时掌握资金动态，及时了解交易情况，做出更加明智的决策，提升管理效率。</p>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </b-container>
    </section>
  </div>
</template>
<script>
import Loader from '../../components/core/loader/Loader'
import logo from '../../assets/images/logo-white.png'
import { core } from '../../config/pluginInit'
import bgImage from '../../assets/images/login/login-2.jpg'
import Swiper from '../../components/core/slider/Swiper'
import SwiperSlide from '../../components/core/slider/SwiperSlide'
export default {
  name: 'AuthLayout',
  components: {
    Loader,
    Swiper,
    SwiperSlide
  },
  mounted() {
    core.index()
  },
  data() {
    return {
      options: {
        slidesPerView: 1,
        loop: true
      },
      logo: logo,
      bgImageURL: bgImage
    }
  }
}
</script>
<style>
@import url("../../assets/css/custom.css");
</style>
